import Cookies from 'js-cookie';
import React, { useContext, useEffect } from 'react';
import { Dropdown, LocaleContext } from 'shared';
import { DropdownElementProps } from 'shared/dropdown/DropdownPopup/DropdownPopup.types';

import { LocaleContainer } from './LocaleDropdown.styles';
import { LocaleDropdownProps } from './LocaleDropdown.types';

export const LocaleDropdown = ({ locales, onChangeLocale }: LocaleDropdownProps) => {
  const context = useContext(LocaleContext);

  useEffect(() => {
    Cookies.set('locale', context.locale, {
      expires: 14,
      sameSite: 'lax',
      secure: window.location.protocol === 'https:',
    });
  }, [context.locale]);

  const handleLocaleChange = (locale: DropdownElementProps) => {
    context.updateLocale(locale.key);
    onChangeLocale(locale.key);
  };

  const currentLocales = locales.filter(locale => context.locale !== locale.key);

  return (
    <LocaleContainer>
      <Dropdown items={currentLocales} onClick={handleLocaleChange}>
        {locales.filter(locale => context.locale === locale.key)[0].label}
      </Dropdown>
    </LocaleContainer>
  );
};
